export const basicComponents = [{
    type: 'input',
    icon: 'icon-input',
    sort: 0,
    options: {
      width: '100%',
      defaultValue: '',
      required: false,
      dataType: 'string',
      pattern: '',
      placeholder: '',
      disabled: false,
      score: 0
    }
  },
  {
    type: 'textarea',
    icon: 'icon-diy-com-textarea',
    sort: 0,
    options: {
      width: '100%',
      defaultValue: '',
      required: false,
      disabled: false,
      pattern: '',
      placeholder: ''
    }
  },
  {
    type: 'number',
    icon: 'icon-number',
    sort: 0,
    options: {
      width: '',
      required: false,
      defaultValue: 0,
      min: '',
      max: '',
      step: 1,
      disabled: false,
      controlsPosition: ''
    }
  },
  {
    type: 'radio',
    icon: 'icon-radio-active',
    sort: 0,
    options: {
      inline: false,
      defaultValue: '',
      showLabel: true,
      options: [{
          value: 'Option 1',
          label: 'Option 1',
          isRemark: false,
          prefix: "", //前缀
          Suffix: "", //后缀
          remark: "", //填写的备注内容
          score: 1,
          relationQuestion:[],
        },
        {
          value: 'Option 2',
          label: 'Option 2',
          isRemark: false,
          prefix: "", //前缀
          Suffix: "", //后缀
          remark: "", //填写的备注内容
          score: 2,
          relationQuestion:[],
        },
        {
          value: 'Option 3',
          label: 'Option 3',
          isRemark: false,
          prefix: "", //前缀
          Suffix: "", //后缀
          remark: "", //填写的备注内容
          score: 3,
          relationQuestion:[],
        }
      ],
      required: false,
      width: '',
      score: 0,
      remote: false,
      remoteOptions: [],
      props: {
        value: 'value',
        label: 'label'
      },
      remoteFunc: '',
      disabled: false,
    },
    
    isGroup: false,
    groupOptions: [{
      name: "group1",
      inline: false,
      defaultValue: '',
      label: "组1",
      showLabel: false,
      required: false,
      width: '',
      remote: false,
      remoteOptions: [],
      props: {
        value: 'value',
        label: 'label'
      },
      remoteFunc: '',
      disabled: false,
      options: [{
          value: 'Option 1',
          label: 'Option 1',
          isRemark: false,
          prefix: "", //前缀
          Suffix: "", //后缀
          remark: "", //填写的备注内容
          score: 3,
        },
        {
          value: 'Option 2',
          label: 'Option 2',
          isRemark: false,
          prefix: "", //前缀
          Suffix: "", //后缀
          remark: "", //填写的备注内容
          score: 3,
        },
        {
          value: 'Option 3',
          label: 'Option 3',
          isRemark: false,
          prefix: "", //前缀
          Suffix: "", //后缀
          remark: "", //填写的备注内容
          score: 3,
        }
      ]

    }, {
      name: "group2",
      inline: false,
      defaultValue: '',
      label: "组2",
      showLabel: false,
      required: false,
      width: '',
      remote: false,
      remoteOptions: [],
      props: {
        value: 'value',
        label: 'label',

      },
      remoteFunc: '',
      disabled: false,
      options: [{
          value: 'Option 1',
          label: 'Option 1',
          isRemark: false,
          prefix: "", //前缀
          Suffix: "", //后缀
          remark: "", //填写的备注内容
          score: 3,
        },
        {
          value: 'Option 2',
          label: 'Option 2',
          isRemark: false,
          prefix: "", //前缀
          Suffix: "", //后缀
          remark: "", //填写的备注内容
          score: 3,
        },
        {
          value: 'Option 3',
          label: 'Option 3',
          isRemark: false,
          prefix: "", //前缀
          Suffix: "", //后缀
          remark: "", //填写的备注内容
          score: 3,
        }
      ]
    }],
  },
  {
    type: 'checkbox',
    icon: 'icon-check-box',
    sort: 0,
    options: {
      inline: false,
      defaultValue: [],
      showLabel: false,
      options: [{
          value: 'Option 1',
          label: 'Option 1',
          score: 1,
        },
        {
          value: 'Option 2',
          label: 'Option 2',
          score: 2,
        },
        {
          value: 'Option 3',
          label: 'Option 3',
          score: 3,
        }
      ],
      score: 0,
      required: false,
      width: '',
      remote: false,
      remoteOptions: [],
      props: {
        value: 'value',
        label: 'label'
      },
      remoteFunc: '',
      disabled: false,
    }
  },
  {
    type: 'time',
    icon: 'icon-time',
    sort: 0,
    options: {
      defaultValue: '21:19:56',
      readonly: false,
      disabled: false,
      editable: true,
      clearable: true,
      placeholder: '',
      startPlaceholder: '',
      endPlaceholder: '',
      isRange: false,
      arrowControl: true,
      format: 'HH:mm:ss',
      required: false,
      width: '',
    }
  },
  {
    type: 'date',
    icon: 'icon-date',
    sort: 0,
    options: {
      defaultValue: '',
      readonly: false,
      disabled: false,
      editable: true,
      clearable: true,
      placeholder: '',
      startPlaceholder: '',
      endPlaceholder: '',
      type: 'date',
      format: 'yyyy-MM-dd',
      timestamp: false,
      required: false,
      width: '',
    }
  },
  {
    type: 'rate',
    icon: 'icon-pingfen1',
    sort: 0,
    options: {
      defaultValue: null,
      max: 5,
      disabled: false,
      allowHalf: false,
      required: false
    }
  },
  {
    type: 'color',
    icon: 'icon-color',
    sort: 0,
    options: {
      defaultValue: '',
      disabled: false,
      showAlpha: false,
      required: false
    }
  },
  {
    type: 'select',
    icon: 'icon-select',
    sort: 0,
    options: {
      defaultValue: '',
      multiple: false,
      disabled: false,
      clearable: false,
      placeholder: '',
      required: false,
      showLabel: false,
      width: '',
      options: [{
          value: 'Option 1',
          label: 'Option 1',
          score: 1,
        },
        {
          value: 'Option 2',
          label: 'Option 2',
          score: 2,
        }, {
          value: 'Option 3',
          label: 'Option 3',
          score: 3,
        }
      ],
      remote: false,
      filterable: false,
      remoteOptions: [],
      props: {
        value: 'value',
        label: 'label'
      },
      remoteFunc: ''
    }
  },
  {
    type: 'switch',
    icon: 'icon-switch',
    sort: 0,
    options: {
      defaultValue: false,
      required: false,
      disabled: false,
    }
  },
  {
    type: 'slider',
    icon: 'icon-slider',
    sort: 0,
    options: {
      defaultValue: 0,
      disabled: false,
      required: false,
      min: 0,
      max: 100,
      step: 1,
      showInput: false,
      range: false,
      width: ''
    }
  },
  {
    type: 'text',
    icon: 'icon-wenzishezhi-',
    sort: 0,
    options: {
      width: '100%',
      defaultValue: 'text',
      customClass: '',

    }
  }
]

export const advanceComponents = [{
    type: 'blank',
    icon: 'icon-zidingyishuju',
    options: {
      defaultType: 'String'
    }
  },
  {
    type: 'imgupload',
    icon: 'icon-tupian',
    options: {
      defaultValue: [],
      size: {
        width: 100,
        height: 100,
      },
      width: '',
      tokenFunc: 'funcGetToken',
      token: '',
      domain: 'http://pfp81ptt6.bkt.clouddn.com/',
      disabled: false,
      length: 8,
      multiple: false,
      isQiniu: false,
      isDelete: false,
      min: 0,
      isEdit: false,
      action: 'https://jsonplaceholder.typicode.com/photos/'
    }
  },
  {
    type: 'editor',
    icon: 'icon-fuwenbenkuang',
    options: {
      defaultValue: '',
      width: ''
    }
  },
  {
    type: 'cascader',
    icon: 'icon-jilianxuanze',
    options: {
      defaultValue: [],
      width: '',
      placeholder: '',
      disabled: false,
      clearable: false,
      remote: true,
      remoteOptions: [],
      props: {
        value: 'value',
        label: 'label',
        children: 'children'
      },
      remoteFunc: ''
    }
  }
]

export const layoutComponents = [{
  type: 'grid',
  icon: 'icon-grid-',
  columns: [{
      span: 12,
      list: []
    },
    {
      span: 12,
      list: []
    }
  ],
  options: {
    gutter: 0,
    justify: 'start',
    align: 'top'
  }
}]



// WEBPACK FOOTER //
// ./src/components/draggleForm/componentsConfig.js